<template>
  <div id="HomePage">
    <div id="first-row" class="container-fuild">
      <div class="row-container"> 
        <div class="row-left wow slideInUp">
          <div class="title-one">
            ANT 国际通讯平台提升客户体验
          </div>
          <div class="title-two">
            ANT 为企业提供稳定、安全的全球短信通信平台，支持身份验证、通知提醒、营销推广等多种场景。通过灵活 API 接口，帮助企业轻松实现全球用户连接，提升客户互动体验。
          </div>
          <div class="contactBtn" @click="handleContactClick">联系我们</div>
        </div>
        <div class="chat-box">
          <img class="chat-img" src="@/assets/img/chat.png" alt="">
        </div>
      </div>
    </div>
    <div id="second-row" class="container-fluid">
      <div class="service-title-one">客户沟通与互动服务</div>
      <div class="service-container-one">
        <div class="service-container">
        <!-- 按钮样式 Tab 切换 -->
          <div class="custom-tab-buttons">
            <button
              v-for="tab in tabs"
              :key="tab.key"
              class="custom-tab-button"
              :class="{ active: activeTab === tab.key }"
              @click="handleTabChange(tab.key)"
            >
              {{ tab.label }}
            </button>
          </div>
    
          <!-- 动态内容区域 -->
          <div class="tab-content wow fadeInUp" data-wow-delay="0.5s">
            <div
              v-for="item in tabContents"
              :key="'content2' + item.key"
              v-show="activeTab === item.key"
              class="content-section"
            >
              <div class="item-title">{{ item.title }}</div>
              <ul class="feature-list">
                <li v-for="(feature, idx) in item.features" :key="idx">
                  <a-icon type="check" /> {{ feature }}
                </li>
              </ul>
                </div>
            <div 
              class="item-img" 
                v-for="img in imgs"
                :key="'img1' + img.key"
                v-show="activeTab === img.key"
                >
              <img class="content-img" :src="img.src" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="second-row" class="container-fluid">
      <div class="service-title-one">验证与技术支持服务</div>
      <div class="service-container-one">
        <div class="service-container">
        <!-- 按钮样式 Tab 切换 -->
          <div class="custom-tab-buttons">
            <button
              v-for="tab in tabsOne"
              :key="tab.key"
              class="custom-tab-button"
              :class="{ active: activeTabOne === tab.key }"
              @click="handleTab(tab.key)"
            >
              {{ tab.label }}
            </button>
          </div>
    
          <!-- 动态内容区域 -->
          <div class="tab-content wow fadeInUp" data-wow-delay="0.3s">
            <div
              v-for="item in tabContentsOne"
              :key="'content2' +item.key"
              v-show="activeTabOne === item.key"
              class="content-section"
            >
              <div class="item-title">{{ item.title }}</div>
              <ul class="feature-list">
                <li v-for="(feature, idx) in item.features" :key="idx">
                  <a-icon type="check" /> {{ feature }}
                </li>
              </ul>
                </div>
            <div 
              class="item-img-one" 
                v-for="img in imgsOne"
                :key="'img2' + img.key"
                v-show="activeTabOne === img.key"
                >
              <img class="content-img-one" :src="img.src" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 在线文档 -->
    <div id="third-row" class="container-fluid">
      <div class="third-title">启动项目</div>
      <div class="third-container">
        <div class="third-content">
        <div class="third-left">
          <div class="third-left-title">深受开发人员喜爱的文档</div>
          <div class="third-left-text">
            只需几行代码即可充满信心地构建并促进您的业务！
          </div>
          <div class="third-left-text">选择您喜欢的代码语言，使用最快、最可靠的云通信 API 构建强大的应用程序。</div>
          <button class="third-btn" @click="handleAPIDocsClick()">阅读API文档</button>
        </div>
        <div class="third-right">
          <CodeTabs />
        </div>
      </div>
      </div>
    </div>
    <!-- 客户评价 -->
    <div id="customer" class="container-fuild">
      <div class="container customer-container">
        <p class="customer-title text-center">客户使用真实效果</p>
        <div class="swiper-container customer-swiper hidden-xs">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide customer-block"
              v-for="(item,index) in customerList"
              :key="index"
            >
              <div class="customer-logo">
                <img class="center-block" :src="item.logo" alt="logo">
              </div>
              <div class="customer-content2">{{item.title}}</div>
              <div class="customer-content1">
                {{item.content}}
              </div>
            </div>
          </div>
        </div>
        <div class="row visible-xs customer-block">
          <div class="col-xs-6" v-for="(item,index) in customerList" :key="index">
            <div class="customer-logo">
              <img class="center-block" :src="item.logo" alt="logo">
            </div>
            <div class="customer-content1">
              <small>{{item.content}}</small>
            </div>
            <div class="customer-content2">
              <small>{{item.title}}</small>
            </div>
          </div>
        </div>
      </div>
    </div>

   
  </div>
</template>
<script>
import LanguageSwitch from '@/components/LanguageSwitch.vue'
import Swiper from "swiper";
import { WOW } from 'wowjs';
import CodeTabs from '@/components/CodeTabs.vue'
export default {
  name: "HomePage",
  components: { CodeTabs, LanguageSwitch },
  data() {
    return {
      activeTab: 'g1-1', // 默认激活短信tab
      tabs: [
        { key: 'g1-1', label: 'WhatsApp' },
        { key: 'g1-2', label: '营销短信' },
        { key: 'g1-3', label: '预测式外呼' },
        { key: 'g1-4', label: '话机服务' }
      ],
      tabContents: [
        {
          key: 'g1-1',
          title: 'WhatsApp for Business',
          features: [
            '通过 WhatsApp 验证用户，无需记住密码。提高验证成功率并降低验证成本。',
            '利用 WhatsApp 的富媒体通过引人入胜的营销信息展示您的产品优势，从而提高转化率。',
            '让您的服务团队能够通过 WhatsApp 接收和响应客户询问，提供无缝、贴心的支持服务。'
          ],
        },
        {
          key: 'g1-2',
          title: '营销短信',
          features: [
            '通过定向营销短信精准触达目标用户，激发客户兴趣和购买意愿提升转化率。',
            '支持批量发送、模板定制与实时数据追踪，让营销过程更精准、更高效、更智能。',
            '无论是节日促销、新品发布，还是品牌传播推广，都能高效轻松实现。'
          ],
        },
        {
          key: 'g1-3',
          title: '预测式外呼',
          features: [
            '通过 AI 和规则引擎智能判断呼叫时机，提高接通率和客户满意度。',
            '自动跳过占线、关机号码，降低人工干预，提升外呼效率。',
            '适用于催收提醒、客户回访、意向激活等场景。'
          ],
        },
        {
          key: 'g1-4',
          title: '话机服务',
          features: [
            '提供软硬件一体的语音通话方案，支持 Web 网页直拨与实体话机同步使用。',
            '界面简洁，支持呼叫记录、通话录音、自动拨号等功能。',
            '满足客服中心、销售团队等多种使用场景的高效通信需求。'
          ],
        }
      ],
      activeTabOne:'g2-1', // 默认激活短信tab
      tabsOne: [
        { key: 'g2-1', label: 'OTP' },
        { key: 'g2-2', label: '号码筛选' },
        { key: 'g2-3', label: '其他服务' },
      ],
      tabContentsOne: [
        {
          key: 'g2-1',
          title: '一次性验证码(OTP)',
          features: [
            '通过 WhatsApp 快速发送一次性验证码，保障账户安全并提升验证体验。',
            '用户无需记忆密码，凭 OTP 即可完成登录或操作，提高转化效率。',
            '适用于登录验证、支付确认、身份认证等多种高频业务场景。'
          ],
        },
        {
          key: 'g2-2',
          title: '号码筛选(HLR + MNP)',
          features: [
            '基于 HLR 与 MNP 技术识别号码状态，有效筛除无效和停机号码。',
            '提升消息送达率，避免资源浪费，降低运营成本和营销干扰。',
            '适用于精准营销、短信投放、外呼前数据清洗等核心环节。'
          ],
        },
        {
          key: 'g2-3',
          title: '其他服务(IVR)',
          features: [
            '支持多层级语音导航交互，引导客户自助完成常见业务操作。',
            '降低人工服务压力，节约人力成本，提升服务自动化水平。',
            '适用于咨询热线、预约提醒、售后支持等智能语音场景。'
          ],
        },
      ],
      customerList: [
        {
          logo: require("@/assets/img/up-pic.png"),
          title: "月度订单增长150%",
          content: "跨境电商客户订单显著增长。"
        },
        {
          logo: require("@/assets/img/my-pic.png"),
          title: "客户满意度97%",
          content: "消息触达快，服务满意度提升。"
        },
        {
          logo: require("@/assets/img/hssd-pic.png"),
          title: "营销触达率达99.5%",
          content: "活动通知精准送达用户。"
        },
        {
          logo: require("@/assets/img/sd-pic.png"),
          title: "验证耗时缩短70%",
          content: "验证流程提速，注册更顺畅。"
        },
        {
          logo: require("@/assets/img/hf-pic.png"),
          title: "回访响应率翻倍",
          content: "自动提醒提升客户响应效率。"
        }
      ],

      serverList: [
        {
          logo: require("@/assets/img/service1.jpg"),
          title: "用户友好",
          content: "<p>在线平台和开发文档易于使用，多语言API可快速访问。</p>"
        },
        {
          logo: require("@/assets/img/service2.jpg"),
          title: "更可靠的服务",
          content: "<p>远程协助工具支持，快速定位并解决各类问题</p>"
        },
        {
          logo: require("@/assets/img/service3.jpg"),
          title: "更准确的数据",
          content: "<p>实时沟通，精准反馈提升数据处理效率与准确率</p>"
        },
        {
          logo: require("@/assets/img/service4.jpg"),
          title: "降低成本/价格",
          content: "<p>零月租费、零服务费，定价公开透明，账单清晰合理。</p>"
        }
      ],
      imgs: [
        {
          key: 'g1-1',
          src: require("@/assets/img/whatsApp-bj.png"),
        },
        {
          key: 'g1-2',
          src: require("@/assets/img/yx-bj.png"),
        },
        {
          key: 'g1-3',
          src: require("@/assets/img/wc-bj.png"),
        },
        {
          key: 'g1-4',
          src: require("@/assets/img/yy-bj.png"),
        },
      ],
      imgsOne: [
        {
          key: 'g2-1',
          src: require("@/assets/img/yzm.png"),
        },
        {
          key: 'g2-2',
          src: require("@/assets/img/hm.png"),
        },
        {
          key: 'g2-3',
          src: require("@/assets/img/vir.png"),
        },
      ]
    };
  },
  methods: {
    handleTabChange(key) {
      this.activeTab = key
    },
    handleTab(key) {
      this.activeTabOne = key
    },
    handleAPIDocsClick() {
      window.location.href = "https://doc.antgst.com/";
    },
    handleContactClick() {
      this.$router.push('/contactSale')
    }
  },
  mounted() {
    /* banner-swiper */
    new Swiper(".banner-swiper", {
      loop: true, // 循环模式选项
      effect: 'fade',
      //自动播放
      autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false
      },
      // 如果需要分页器
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      // 如果需要前进后退按钮
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      // 延迟加载
      lazy: {
        loadPrevNext: true
      },
      observer: true, //修改swiper自己或子元素时，自动初始化swiper
      observeParents: true //修改swiper的父元素时，自动初始化swiper
    });
    /* customer-swiper */
    new Swiper(".customer-swiper", {
      loop: true, // 循环模式选项
      slidesPerView: 3,
      //自动播放
      autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false
      },
      // 如果需要前进后退按钮
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      },
      observer: true, //修改swiper自己或子元素时，自动初始化swiper
      observeParents: true //修改swiper的父元素时，自动初始化swiper
    });
    /* wowjs动画 */
    var wow = new WOW({
      boxClass: 'wow',
      animateClass: 'animated',
      offset: 0,
      mobile: true,
      live: true
    })
    wow.init();
  }
};
</script>
<style lang="less" scoped>
/* 整体盒子 */
#HomePage {
  width: 100%;
  margin-top: 80px;
}
#first-row {
  background-color: rgb(224, 242, 255);
  padding: 30px 50px;
  .row-container {
    width: 90%; /* 使用更宽松的宽度百分比 */
    max-width: 1400px; /* 添加最大宽度限制 */
    display: flex;
    margin: 0 auto;
    padding: 20px 0;
    .row-left {
      min-height: 400px; /* 最小高度替代固定高度 */
      flex: 1 1 100%; /* 基础占满宽度 */
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 20px;
      margin-bottom: 30px; /* 移动端下增加底部间距 */
  
      .title-one {
        font-size: clamp(2rem, 5vw, 3.5rem); /* 响应式字体大小 */
        font-weight: 600;
        font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
        line-height: 1.2; /* 优化行高 */
      }
  
      .title-two {
        font-size: clamp(1.5rem, 2vw, 1.25rem); /* 响应式字体大小 */
        font-weight: 400;
        width: 100%; /* 宽度自适应 */
        max-width: 900px; /* 最大宽度限制 */
        font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
        margin-top: 10px;
      }
  
      .contactBtn {
        width: 180px;
        height: 50px;
        font-weight: 550;
        font-size: 20px;
        color: white;
        border-radius: 40px;
        background-color: rgb(36, 147, 110);
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 30px;
        font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
        /* 添加响应式按钮样式 */
        @media (max-width: 480px) {
          width: 100%;
          max-width: 300px;
        }
      }
    }
  
    .chat-box {
      min-height: 300px; /* 最小高度替代固定高度 */
      flex: 1 1 100%; /* 基础占满宽度 */
      display: flex;
      align-items: center;
      justify-content: center; /* 居中显示 */
      padding: 20px;
      .chat-img {
        height: auto; /* 高度自适应 */
        max-height: 500px; /* 最大高度限制 */
        width: 100%;
        max-width: 600px; /* 最大宽度限制 */
        border-radius: 10%;
      }
    }
  }

  /* 平板设备适配 (768px以上) */
  @media (min-width: 768px) {
    .row-left {
      margin-bottom: 0;
      padding: 40px;
    }

    .chat-box {
      padding: 40px;
    }
  }

  /* 桌面设备适配 (992px以上) */
  @media (min-width: 992px) {
    flex-wrap: nowrap; /* 恢复不换行 */

    .row-left {
      flex: 1.2;
      min-height: 600px;
    }

    .chat-box {
      flex: 0.8;
      min-height: 600px;
    }
  }
}
// 提供的服务
#second-row {
  width: 100%;
  padding: 60px 40px;
  .service-title-one {
    width: 100%;
    // margin-top: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 550;
    font-size: 40px;
    font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
  }
  .service-container-one {
    display: flex;
    justify-content: center;
    margin-top: 40px;
    .service-container {
      width: 1200px;

    .custom-tab-buttons {
      display: flex;
      justify-content: center;
      gap: 12px;
      margin-bottom: 24px;
    
     // 默认按钮样式
     .custom-tab-button {
        width: 135px;
        height: 44px;
        background: white;
        color: #333;
        border: 1px solid #d9d9d9;
        font-weight: 600 !important;
        border-radius: 30px;
        padding: 6px 20px;
        font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
        // font-size: 16px;
        transition: all 0.3s;
        font-size: 18px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-color: #fff;
        &.active {
          background: rgb(36, 147, 110);
          color: white;
          border-color: rgb(36, 147, 110);
        }
      }
    }

    // 内容区域
    .tab-content {
      margin-top: 50px;
      display: flex;
      padding: 0 15px;
      .content-section {
        margin-top: 60px;
        margin-left: 100px;
        .item-title {
          font-size: 30px;
          color: #333;
          font-weight: 600;
          margin-bottom: 15px;
          font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
        }

        .feature-list {
          list-style: none;
          padding: 0;

          li {
            font-size: 14px;
            padding: 10px 0;
            display: flex;
            align-items: center;
            transition: all 0.3s;
            font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
            &:hover {
              transform: translateX(5px);
            }

            .anticon {
              color: #52c41a;
              margin-right: 8px;
            }
          }
        }

       
      }
      .item-img {
        margin-left: 70px;
        .content-img {
          width: 400px;
          height: 300px;
          
        }
      }
      .item-img-one {
        margin-left: 70px;
        .content-img-one {
          width: 450px;
          height: 300px;
        }
      }
    }
  }
  }
}
// 启动项目
#third-row { 
  width: 100%;
  padding: 60px 40px 30px 40px;
  .third-title {
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 550;
    font-size: 40px;
    font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
  }
  .third-container {
    display: flex;
    justify-content: center;

    .third-content {
      display: flex;
      margin-top: 40px;
      .third-left {
        margin-top: 50px;
        margin-right: 20px;
        .third-left-title {
          font-size: 30px;
          font-weight: 600;
          margin-bottom: 25px;
          font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
        }
        .third-left-text {
          font-size: 14px;
          margin-bottom: 10px;
          font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
        }
        .third-btn {
          width: 130px;
          height: 44px;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: rgb(36, 147, 110);
          color: #fff;
          font-size: 18px;
          border-radius: 30px;
          border: none; 
          margin-top: 20px;
          font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
        }
      }
      .third-right {
        margin-left: 20px;
        // width: 500px;
        height: 400px;
        flex: 1;                    /* 响应式伸缩 */
        max-width: 50%;            /* 或使用百分比宽度 */
        min-width: 320px;
      }
    } 
  }
  
}
// 响应式设计
@media (max-width: 768px) {
  #second-row {
    padding: 20px 0;

    .ant-card {
      .ant-tabs {
        &-tab {
          padding: 12px 15px;
          font-size: 14px;
        }
      }
    }
  }
}
/* 客户评价 */
#customer {
  padding-top: 50px;
  padding-bottom: 70px;
  box-sizing: border-box;
  /* background: #efefef; */
  // background-color: rgb(224, 242, 255);
  transition: all ease 0.6s;
}
#customer .customer-container  { 
  width: 85%;

}
#customer .customer-container .swiper-container { 
  border-radius: 20px;

}
#customer .customer-title {
  font-size: 36px;
  font-weight: 700;
  margin: 0 0 30px;
  font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
}
#customer .customer-block {
  background-color: rgb(224, 242, 255);
  padding: 30px 80px;
  
}
#customer .customer-logo img {
  width: 94px;
  height: 94px;
}
#customer .customer-yh img {
  width: 34px;
  height: 34px;
}
#customer .customer-content1 {
  padding-top: 20px;
  font-size: 16px;
  display: flex;
  justify-content: center;
  font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
}
#customer .customer-content2 {
  /* padding-top: 20px; */
  display: flex;
  justify-content: center;
  margin-top: 20px;
  font-size: 25px;
  font-weight: 600;
  border-bottom: 1px solid rgb(36, 147, 110);
  padding-bottom: 20px;
  font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
}
/* 为什么选择我们 */
#whyChooseUs {
  padding: 50px 100px;
  .container {
    .whyChooseUs-title {
      margin-bottom: 30px;
      .whyChooseUs-title-text {
        font-size: 38px;
        font-weight: 700;
      } 
    }
    .row {
      display: flex;
      justify-content: center;
      width: 1400px;
      height: 300px;
      margin-left: -100px;
      display: flex;
      .server-wrapper {
        width: 100%;
        border: 1px solid rgba(0, 0, 0, 0.1);
        margin-right: 60px;
        border-radius: 10px;
        box-shadow: 5px 4px 12px rgba(224, 242, 255);
        
        &:hover {
            box-shadow: 10px 4px 12px rgba(224, 242, 255); 
          }
        .server-block  {
          padding: 20px;
          .center-block {
            width: 100px;
            height: 100px;
            border-radius: 50%;
          }
        }
        .text-center {
          margin-top: 30px;
          font-size: 30px;
          font-weight: bold;
        }
        .text-content {
          padding-top: 25px;
          font-size: 16px;
        }
      }
    }
  }
}

/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
  #swiper {
    height: 200px;
  }
  #bigData {
    padding: 30px;
  }
  #bigData .bigData-title {
    font-size: 20px;
  }
  #bigData .bigData-device {
    font-size: 20px;
    margin: 10px 0 10px;
  }
  #contactUs {
    height: 200px;
    transition: all ease 0.6s;
  }
  #contactUs .contactUs-container {
    padding-top: 0;
  }
  #contactUs .contactUs-container h1 {
    font-size: 25px;
  }
  #contactUs .contactUs-container h3 {
    font-size: 18px;
  }
  #contactUs .contactUs-container button {
    width: 200px;
    height: 30px;
    margin-top: 20px;
  }
  #contactUs .contactUs-container .contactUs-contactWay span {
    display: inline-block;
    width: 28px;
    height: 28px;
    margin: 10px;
  }
  #customer {
    padding: 30px 0;
    box-sizing: border-box;
    background: #fff;
  }
  #customer .customer-title {
    font-size: 16px;
    font-weight: bold;
  }
  #customer .customer-logo img {
    width: 40px;
    height: 40px;
  }
  #customer .customer-block {
    padding: 30px;
  }
  #customer .customer-block > div {
    padding: 30px 0;
  }

  #whyChooseUs {
    padding: 20px 0;
    transition: all ease 0.6s;
  }
}

/* 媒体查询（平板） */
@media screen and (min-width: 768px) and (max-width: 996px) {
  #swiper {
    height: 400px;
  }
  #bigData {
    padding: 60px;
  }
  #bigData .bigData-title {
    font-size: 30px;
  }
  #bigData .bigData-device {
    font-size: 30px;
    margin: 30px 0 15px;
  }
  #contactUs {
    height: 300px;
  }
  #contactUs .contactUs-container {
    padding-top: 50px;
  }
  #contactUs .contactUs-container h1 {
    font-size: 30px;
  }
  #contactUs .contactUs-container h3 {
    font-size: 20px;
  }
  #contactUs .contactUs-container button {
    width: 300px;
    height: 50px;
    margin-top: 30px;
  }
  #contactUs .contactUs-container .contactUs-contactWay span {
    display: inline-block;
    width: 32px;
    height: 32px;
    margin: 15px;
  }
  #customer .customer-title {
    font-size: 36px;
    font-weight: 700;
  }
}
</style>




// WEBPACK FOOTER //
// src/view/HomePage.vue